import React from "react";
import { connect } from "react-redux";
import { Popup, ScrollView } from "devextreme-react";
import Form from "../Form";

function LotDataEntryPopup(props) {
    return (<>
        {props.showPopup.visible == true && (
            <Popup
                visible={props.showPopup.visible}
                onHiding={() => props.setShowPopup(prevFormData => ({ ...prevFormData, visible: false }))}
                dragEnabled={false}
                hideOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                title={props.title}
                container="#root"
                width="90vw"
                height="90vh"
            >
                <ScrollView height="100%" width="100%">
                    {props.showPopup.visible == true && (<Form id={props.showPopup.id} />)}
                </ScrollView>
            </Popup>
        )}
    </>

    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LotDataEntryPopup);
